'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const shortid = require('shortid');

const styles = require('./arrowStyles.scss');

/**
 * Represents a wrapper with dots navigation for carousels.
 * @class
 */
class DotCarousel extends React.Component {
    componentDidMount() {
        // If auto prop is set to true, the carousel with switch pages automatically.
        if (this.props.auto) {
            this._run();
        }
    }

    componentWillUnmount() {
        if (this.props.auto) {
            clearInterval(this._timer);
        }
    }

    /**
     * Method used to create the dots for carousel pagination.
     *
     * @param {function} callback - optional callback.
     * @returns {object} - dots JSX.
     */
    _createDots(callback) {
        const { model } = this.props;

        if (model.canPaginate()) {
            const totalPages = model.getTotalPages();
            const active = model.getState().page;
            const dots = [];
            // TODO: Remove this and adjust default styles?
            const dotControlsClass = classnames(
                styles.dotControls,
                this.props.classNames.dotControls
            );

            for (let index = 0; index < totalPages; index++) {
                const classes = [`${styles.dot}`];

                if (index === active) {
                    classes.push(`${styles.current}`);
                }

                dots.push(this._createDot(index, classes, callback));
            }

            return <ul className={dotControlsClass}>{dots}</ul>;
        } else {
            return null;
        }
    }

    /**
     * Method used to create an individual dot for dotted pagination.
     *
     * @param {int} - index, unique key for each dot.
     * @param {array} - array of classes to be applied to the dot.
     * @returns {object} - JSX of a dot.
     */
    _createDot(index, classes, callback) {
        const { dot } = this.props.classNames;
        const dotClassName = styles[this.props.dotsColorType];
        const dotClassNames = classnames({
            [dotClassName]: dotClassName,
            [dot]: dot,
        });

        return (
            <li key={shortid.generate()} className={styles.dotWrapper}>
                <span
                    className={`${classes.join(' ')} ${dotClassNames}`}
                    key={index}
                    onClick={() => this._onDotClick(index, callback)}
                >
                    {index}
                </span>
            </li>
        );
    }

    _onDotClick(index, callback) {
        const { onDotClick, model } = this.props;

        this.props.setPage(index, model, callback);
        onDotClick(index);
    }

    /**
     * Method used to start the automatic carousel run.
     */
    _run() {
        const {
            _itemsPerPage: itemsPerPage,
            _itemCount: totalItems,
            _state: state,
        } = this.props.model;

        const auto = () => {
            this._timer = setInterval(() => {
                const page = state.page;
                const totalPages = totalItems / itemsPerPage;
                let nextPage = page + 1;
                if (nextPage >= totalPages) {
                    nextPage = 0;
                }
                this.props.setPage(nextPage, this.props.model);
            }, this.props.autoDuration);
        };

        this.restartInterval = () => {
            clearInterval(this._timer);
            auto();
        };
        auto();
    }

    render() {
        const { createCarousel, classNames, dotsPosition, auto } = this.props;

        const dotCarouselWrapperProps = {
            className: classnames(styles.dotCarouselWrapper, classNames.dotCarouselWrapper || ''),
            'data-tn': auto ? 'auto-dots' : '',
        };

        const dotsPositionClass = classnames({
            'float-r': dotsPosition === 'right',
            'float-l': dotsPosition === 'left',
        });

        return (
            <div {...dotCarouselWrapperProps}>
                <div className="arrow-carousel-wrapper">{createCarousel()}</div>
                <div className={dotsPositionClass}>
                    {auto ? this._createDots(this.restartInterval) : this._createDots()}
                </div>
                <div className={styles.clear} />
            </div>
        );
    }
}

DotCarousel.propTypes = {
    model: PropTypes.object.isRequired,
    onDotClick: PropTypes.func,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    dotsPosition: PropTypes.oneOf(['left', 'right']),
    createCarousel: PropTypes.func,
    setPage: PropTypes.func,
    classNames: PropTypes.object,
    auto: PropTypes.bool,
    autoDuration: PropTypes.number,
};

DotCarousel.defaultProps = {
    auto: false,
};

module.exports = DotCarousel;



// WEBPACK FOOTER //
// ./assets/js/global/components/carousel/views/DotCarousel.jsx